import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as _ from '../../lodash';
import inputParser from '../../../components/components/widget/input_parser';
import { onDurationOptionSet } from '../../../components/actions/product.js';
import Button from '../../components/Common/Button';

const parseDefaultValue = (field) => {
  // {\"type\":\"dropdown\",\"label\":\"dfdfd\",\"key\":\"_dfdfd\",\"options\":[\"aaa\"]}
  switch (field.type) {
    case 'dropdown':
    case 'radio':
    case 'checkbox':
      return { defaultValue: field.options };
    default:
      return { defaultValue: '' };
  }
};

const errorFieldClass = (errors, field) => {
  let classStyle = '',
      message = '';

  const error = errors.find(e => e.key == field && !e.fieldChanged);
  if (error) {
    classStyle = 'error';
    message = error.value
  }

  return { classStyle, message }
}

class FieldInput extends  Component {
  render() {
    const { type, fieldKey, onChange, style } = this.props,
          { classStyle, message } = errorFieldClass(this.props.errors, fieldKey);

    const dom = inputParser({
      type,
      key: fieldKey,
      defaultSetting: { [fieldKey]: this.props.defaultValue },
      currentSetting: { [fieldKey]: this.props.currentValue },
      onChange,
      includeBlank: true,
      classStyle
    });

    return (
      <div className="field-input-container pure-form" key={fieldKey}>
        <label className="control-label">
          {this.props.label}
        </label>
        <div className="content">
          {dom}
          { message != '' &&
          <div className='field-error-message' style={{color: style.errorText.color}}>{message}</div>
          }
        </div>
      </div>
    )
  }
}

class RepeatedBookingFields extends Component {
  componentDidMount() {
    const { bookingFields } = this.props,
          requiredPresent = bookingFields.filter((field) => !!field.repeated && field.required).length > 0;

    if (requiredPresent) this.props.onAddRepeatedField(bookingFields);
  }

  defaultRepeatedValues(field) {
    let { key } = field;
    if (key) return this.props.additionalDetails[key] || [];
    return [];
  }

  removeItems(index) {
    const { bookingFields, additionalDetails } = this.props,
          required = bookingFields.filter((field) => !!field.repeated && field.required);

    if (required.length == 0 || additionalDetails[required[0].key].length > 1) {
      this.props.onRemoveRepeatedFields(this.props.bookingFields, index);
    }
  }

  repeatedFieldsNumbers(repeated) {
    let max = 0;
    repeated.forEach((r) => { max = Math.max(max, (this.props.additionalDetails[r.key] || []).length) });
    return max;
  }

  defaultKey(field, index) {
    return field.key || ('field' + index);
  }

  render() {
    const { bookingFields, additionalDetails, style, errors } = this.props,
          repeated = bookingFields.filter((field) => !!field.repeated),
          repeatedValueCount = repeated[0] ? this.defaultRepeatedValues(repeated[0]).length : 0,
          arrayOfIndex = [...Array(repeatedValueCount).keys()].map(x => x++);
    let fieldsNum = this.repeatedFieldsNumbers(repeated);

    return (
      <div className="repeated-fields">
        {
          arrayOfIndex.map((index) => {
            return (
              <div className="repeated-items" key={index} style={{border: `1px solid ${style.body.color}`}}>
                <div key={`delete-${index}`} className="remove-fields" onClick={this.removeItems.bind(this, index)}>x</div>
                {
                  repeated.map((field, i) => {
                    const fieldKey = this.defaultKey(field, i),
                      { defaultValue } = parseDefaultValue(field),
                      value = this.defaultRepeatedValues(field)[index],
                      key = `${fieldKey}-${index}`,
                      currentValue = value || '';

                    return (
                      <FieldInput
                        key={key}
                        fieldKey={key}
                        type={field.type}
                        defaultValue={defaultValue}
                        currentValue={currentValue}
                        errors={errors}
                        label={field.label}
                        style={this.props.style}
                        onChange={(key, value) => this.props.onChange(field, value, index)}
                      />
                    );
                  })
                }

              </div>
            )
          })
        }

        { repeated.length > 0 &&
          <div style={{textAlign: 'right', paddingTop: '8px'}}>
            <a className="add-fields-link" onClick={() => this.props.onAddRepeatedField(bookingFields)}> Add fields </a>
          </div>
        }
      </div>
    )
  }
}

class NonRepeatedBookingFields extends Component {
  render() {
    const nonRepeated = this.props.bookingFields.filter((field) => !field.repeated),
          { additionalDetails, errors } = this.props;

    return (
      <div className='non-repeated-fields'>
        {nonRepeated.map((field, index) => {
          const { key } = field,
                { defaultValue } = parseDefaultValue(field),
                currentValue = additionalDetails[key] || "";

          return (
            <FieldInput
              key={key}
              fieldKey={key}
              type={field.type}
              defaultValue={defaultValue}
              currentValue={currentValue}
              errors={errors}
              label={field.label}
              style={this.props.style}
              onChange={(key, value) => this.props.onChange(field, value)}
            />
          );
        })}
      </div>
    )
  }
}

export default class BookingFieldsBlock extends Component {
  componentDidMount() {
    this.props.getValidationFn(this.validateAdditionalDetails);
  }

  validateAdditionalDetails = this.validateAdditionalDetails.bind(this);

  validateAdditionalDetails() {
    let errors = [];
    const settings = this.props.bookingFields || [];
    for (const index in settings) {
      const s = settings[index];
      if (s.required) {
        const values = this.props.additionalDetails[s.key];
        if (!this.props.additionalDetails[s.key]) {
          const key = s.repeated ? `${s.key}-0` : s.key;
          this.setError(key, `${s.label}: Required`, errors);
        } else if (Array.isArray(values)) {
          if (values.length == 0) this.setError(`${s.key}-0`, `${s.label}: Required`, errors);
          values.map((v, i) => {
            if (!v) this.setError(`${s.key}-${i}`, `${s.label}: Required`, errors);
          })
        }
      }
    }

    this.props.onSetErrors(errors);

    return errors;
  }

  setError(field, message, errors) {
    errors.push({key: field, value: message, fieldChanged: false});
    return errors;
  }

  render() {
    return (
      <div>
        { this.props.bookingFields.length > 0 &&
          <div className="booking-fields-container" style={{borderColor: `${this.props.style.body.color}`}}>
            <div className='additional-field-label'>
              Additional Information
            </div>
            <NonRepeatedBookingFields {...this.props}/>
            <RepeatedBookingFields {...this.props}/>
          </div>
        }
      </div>
    )
  }
}

BookingFieldsBlock.propTypes = {
  bookingFields: PropTypes.array.isRequired,
  onChange: PropTypes.func,
};
